import { StandardEvents } from '@shopify/events';

function updateGoldenDeliveryTotal(purchase) {
  const total = purchase?.querySelector('[data-gg-delivered]');
  const quantity = purchase?.querySelector('[name="quantity"]');
  if (!total || !quantity) return;
  const count = Number(quantity.value);
  if (!Number.isInteger(count) || count < 1) return;
  const amount = Number(total.dataset.unitPrice) * count + Number(total.dataset.shipping);
  total.querySelector('[data-gg-delivered-value]').textContent = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(amount / 100);
}
document.addEventListener('input', (event) => {
  if (event.target.matches('[data-gg-purchase] [name="quantity"]')) updateGoldenDeliveryTotal(event.target.closest('[data-gg-purchase]'));
});
document.addEventListener('change', (event) => {
  if (event.target.matches('[data-gg-purchase] [name="quantity"]')) updateGoldenDeliveryTotal(event.target.closest('[data-gg-purchase]'));
});
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-gg-quantity]');
  if (!button) return;
  const input = button.closest('.gg-quantity').querySelector('input');
  if (button.dataset.ggQuantity === 'up') input.stepUp();
  else input.stepDown();
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-gg-variant]')) return;
  const option = event.target.selectedOptions[0];
  const purchase = event.target.closest('[data-gg-purchase]');
  const button = purchase.querySelector('[data-gg-add]');
  const input = purchase.querySelector('[name="quantity"]');
  purchase.querySelector('[data-gg-price]').textContent = option.dataset.price;
  const total = purchase.querySelector('[data-gg-delivered]');
  if (total) total.dataset.unitPrice = option.dataset.unitPrice;
  button.disabled = option.dataset.available !== 'true';
  button.textContent = button.disabled ? purchase.dataset.soldLabel : purchase.dataset.addLabel;
  input.min = option.dataset.min || '1';
  input.step = option.dataset.step || '1';
  input.value = input.min;
  if (option.dataset.max) input.max = option.dataset.max;
  else input.removeAttribute('max');
  updateGoldenDeliveryTotal(purchase);
});


let goldenCartRevision = 0;
let goldenCartController;
function renderGoldenCartCount(count) {
  if (!Number.isInteger(count) || count < 0) return;
  document.querySelectorAll('[data-gg-cart]').forEach(link => {
    const counter = link.querySelector('[data-gg-cart-count]');
    if (counter) counter.textContent = String(count);
    const label = count === 1 ? link.dataset.labelOne : link.dataset.labelOther;
    if (label) link.setAttribute('aria-label', label.replace('__COUNT__', String(count)));
  });
}
document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  const revision = ++goldenCartRevision;
  goldenCartController?.abort();
  event.promise?.then(({ cart, detail }) => {
    if (revision !== goldenCartRevision) return;
    renderGoldenCartCount(cart?.totalQuantity ?? detail?.itemCount);
  }).catch(() => {
    if (revision === goldenCartRevision) reconcileGoldenCart();
  });
});
async function reconcileGoldenCart() {
  const link = document.querySelector('[data-gg-cart]');
  if (!link?.dataset.cartUrl) return;
  goldenCartController?.abort();
  const controller = new AbortController();
  goldenCartController = controller;
  const revision = goldenCartRevision;
  try {
    const response = await fetch(link.dataset.cartUrl, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
      signal: controller.signal
    });
    if (!response.ok) return;
    const cart = await response.json();
    if (!controller.signal.aborted && revision === goldenCartRevision) renderGoldenCartCount(cart.item_count);
  } catch {}
}
window.addEventListener('pageshow', event => {
  document.querySelectorAll('[data-gg-purchase]').forEach(updateGoldenDeliveryTotal);
  if (event.persisted) reconcileGoldenCart();
});
if (performance.getEntriesByType('navigation')[0]?.type === 'back_forward') reconcileGoldenCart();

let goldenPrivacyLoading;
function loadGoldenPrivacy() {
  if (window.privacyBanner?.showPreferences) return Promise.resolve();
  if (goldenPrivacyLoading) return goldenPrivacyLoading;
  goldenPrivacyLoading = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
    script.onload = () => resolve();
    script.onerror = () => { script.remove(); reject(new Error('Privacy settings unavailable')); };
    document.head.append(script);
  }).catch(error => { goldenPrivacyLoading = undefined; throw error; });
  return goldenPrivacyLoading;
}
document.addEventListener('click', async event => {
  const button = event.target.closest('[data-gg-cookie-preferences]');
  if (!button) return;
  const status = button.closest('.gg-footer__bottom').querySelector('[data-gg-privacy-error]');
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  status.textContent = '';
  try {
    await loadGoldenPrivacy();
    await window.privacyBanner.showPreferences();
  } catch {
    status.textContent = button.dataset.error;
  } finally {
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
});
